import React, { Component } from 'react';
import IconButton from './IconButton';
import GroupedCallbacks from '../core/GroupedCallbacks';
import AssetsManager from '../assets_management/AssetsManager';
import Once from '../core/Once';
import Urls from '../urls/Urls';
import ParameterError from '../errors/ParameterError';
import EfficientMoveCycle from '../ui_core/EfficientMoveCycle';
import './MiniMap.css';
import isMobile from '../core/isMobile';
const{ throwNotProvided}=ParameterError;
export default class MiniMap extends Component {
	constructor(props){
		super(props);
		const {configuration}=props;
		this._configuration = configuration;
		this._useCurrentPositionIcon = configuration.useCurrentPositionIcon;
		this._elementRef = React.createRef();
		this._mapImageRef = React.createRef();
		this._currentPositionMarkerRef= React.createRef();
		this.toggleShowing = this.toggleShowing.bind(this);
		this.load = this.load.bind(this);
		this.hide = this.hide.bind(this);
		this.setAtOutside360 = this.setAtOutside360.bind(this);
		this._setVisible = this._setVisible.bind(this);
		this._handleClickButtonClose = this._handleClickButtonClose.bind(this);
		this._setCurrentPositionMarkerLeftPercent = this._setCurrentPositionMarkerLeftPercent.bind(this);
		this._setCurrentPositionMarkerTopPercent = this._setCurrentPositionMarkerTopPercent.bind(this);
		this._setCurrentPositionMarkerVisibile = this._setCurrentPositionMarkerVisibile.bind(this);
		this.setAngleRadians = this.setAngleRadians.bind(this);
		this._setupResize = this._setupResize.bind(this);
		this._mapImageError = this._mapImageError.bind(this);
		this._mapImageLoaded = this._mapImageLoaded.bind(this);
		this._groupedCallbacksMapImageLoad = new GroupedCallbacks();
		this._siteJson = null;
		this._visible = false;
		this._fixedAspectRatio = null;
	}
	componentDidMount(){
		const mapImageElement = this._mapImageRef.current;
		const element = this._elementRef.current;
		mapImageElement.addEventListener('load', this._mapImageLoaded);
		mapImageElement.addEventListener('error', this._mapImageError);
		this._setupResize(element);
	}
	_setupResize(element){
		let offsets=null, maxWidth = null;
		const efficientMoveCycle = new EfficientMoveCycle({ 
			element, stopPropagation:false, preventDefault:true, 
			onStart:(e)=>{
				if(this._fixedAspectRatio==null)
					this._fixedAspectRatio = element.offsetWidth/element.offsetHeight;
				offsets= [element.offsetWidth - e.x, element.offsetHeight + e.y];
				element.style.maxWidth = 'none';
				maxWidth= element.parentNode.offsetWidth - 24;
			}, onMove:(e)=>{
				const x = e.x, y=e.y;
				const widthFromHeight = (offsets[1] -y )*this._fixedAspectRatio;
				const heightFromWidth = (x + offsets[0])/this._fixedAspectRatio;
				const l = (widthFromHeight*widthFromHeight)+ (heightFromWidth*heightFromWidth);
				const aspectRatioSquared = this._fixedAspectRatio*this._fixedAspectRatio;
				let height = Math.sqrt(l /(1+aspectRatioSquared));
				let width = height * this._fixedAspectRatio;
				if(width>maxWidth){
					width = maxWidth;
					height = width / this._fixedAspectRatio;
				}
				else{
					if(width < 100)
						width = 100;
					height = width / this._fixedAspectRatio;
				}
				element.style.width = String(width)+'px';
				element.style.height = String(height)+'px';
			}, onEnd:()=>{} , friendlyXY:true
		});
	}
	
	setAtOutside360(outside360UniqueId){
		const markerPositionProportion = this._siteJson?.birdsEyeViews.getDefault().getMarkerPositionForOutside360(outside360UniqueId);
		if(!markerPositionProportion)return;
		this._setCurrentPositionMarkerLeftPercent(markerPositionProportion.x*100);
		this._setCurrentPositionMarkerTopPercent(markerPositionProportion.y*100);
		this._setCurrentPositionMarkerVisibile(true);
		
	}
	setAngleRadians(radians){
		const offset = radians+(this._configuration.miniMapConeOffset!==undefined?this._configuration.miniMapConeOffset:(2*Math.PI/2));
		this._currentPositionMarkerRef.current.style.transform = `translate(-50%,-50%) rotate(${offset}rad)`;
	}
	toggleShowing(){
		this._setVisible(!this._visible);
	}
	hide(){
		this._setVisible(false);
		//this._setCurrentPositionMarkerVisibile(false);
	}
	show(){
		this._setVisible(true);
		//this._setCurrentPositionMarkerVisibile(false);
	}
	load({siteJson}){
		return new Promise((resolve, reject)=>{
			this._siteJson = siteJson;
			if(!siteJson){
				throwNotProvided('siteJson');
			}
			const imageRelativePath =Urls.getAssetsForSite(this._configuration.siteSlug)+siteJson.birdsEyeViews.getDefault().imageRelativePath;
			this._mapImageRef.current.src = imageRelativePath;
			this._groupedCallbacksMapImageLoad.then(()=>{
				this._setVisible(true);
				resolve();
			});
			this._groupedCallbacksMapImageLoad.catch(reject);
		});
	}
	_mapImageError(){
		this._groupedCallbacksMapImageLoad.doCatch(new Error('Error loading map image'));
	}
	_mapImageLoaded(){
		this._groupedCallbacksMapImageLoad.doThen();
	}
	_setVisible(visible){
		if(visible){
			this._element.classList.add('visible');
		}
		else 
			this._element.classList.remove('visible');
		this._visible = visible;
	}
	_setCurrentPositionMarkerLeftPercent(leftPercent){
		this._currentPositionMarkerElement.style.left=`${leftPercent}%`;
	}
	_setCurrentPositionMarkerTopPercent(topPercent){
		this._currentPositionMarkerElement.style.top=`${topPercent}%`;
	}
	_setCurrentPositionMarkerVisibile(visible){
		if(visible)
			this._currentPositionMarkerElement.classList.add('visible');
		else 
			this._currentPositionMarkerElement.classList.remove('visible');
	}
	get _element(){
		return this._elementRef.current;
	}
	get _currentPositionMarkerElement(){
		return this._currentPositionMarkerRef.current;
	}
	_handleClickButtonClose(){
		this.hide();
	}
	render() {
		const currentPosition = this._useCurrentPositionIcon
			?(<div className="current-position-marker-icon" ref={this._currentPositionMarkerRef}>
				<img src ={Urls.assets+'icons/UI_Button_Filter_Plot_Solid.png'}></img>
			</div>)
			:(
				this._configuration.miniMapConeMarkerEnabled
				?
				
				(<div className="current-position-marker cone" ref={this._currentPositionMarkerRef}>
					<img src ={Urls.assets+'icons/cone.png'}></img>
				</div>)
				:
				(<div className="current-position-marker" ref={this._currentPositionMarkerRef}>
					<div className="inner"></div>
				</div>)
			);
		return (<div className="mini-map" ref={this._elementRef}>
			<img className="map-image" ref={this._mapImageRef}/>
				<IconButton className="button-close" imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'}  onClick={this._handleClickButtonClose}></IconButton>
					{currentPosition}
		</div>);
	}
}